export type StreamFeeder = {
	feed: (chunk: string) => void;
};

/**
 * Reads a `Response` body to completion, feeding each decoded chunk to `parser`. Shared by every
 * SSE-shaped fetch stream in the app so abort/cleanup semantics live in one place instead of being
 * re-implemented (and drifting) per call site.
 *
 * Checks `signal.aborted` before each read so an abort in flight stops promptly instead of waiting
 * for the next `reader.read()` to reject.
 */
export const drainEventStream = async (
	body: ReadableStream<Uint8Array>,
	parser: StreamFeeder,
	signal?: AbortSignal,
): Promise<void> => {
	const reader = body.getReader();
	const decoder = new TextDecoder();
	while (true) {
		if (signal?.aborted) {
			await reader.cancel();
			return;
		}
		const { done, value } = await reader.read();
		if (done) break;
		parser.feed(decoder.decode(value, { stream: true }));
	}
	parser.feed(decoder.decode());
};
